import { logUtils } from '@utils'

const operationMap = {
  sortByLibrary: 'querying sort parameters',
  siteLibrary: 'fetching details of selected site library',
  sortByLibraryTable: 'querying sort parameters',
  libraryTablePagination: 'fetching pagination parameters',
  libraryTypes: 'querying specification types',
  plmMaterials: 'querying PLM specification',
  plmColors: 'querying PLM specification',
  products: 'querying products',
  groupedProducts: 'querying products',
  product: 'querying product',
  libraries: 'querying summary for specifications',
  attributes: 'querying product attributes',
  seasons: 'querying seasons',
  hardware: 'querying specifications',
  colors: 'querying specifications',
  color: 'querying specification',
  materials: 'querying specifications',
  material: 'querying specification',
  sketches: 'querying specifications',
  sketch: 'querying specification',
  isColorOutofSync: 'fetching details of whether color is out of sync',
  isMaterialOutofSync: 'fetching details of whether material is out of sync',
  ProductMaterialReference: 'querying product references for specification',
  ProductColorReference: 'querying product references for specification',
  ProductSketchReference: 'querying product references for specification',
  createProduct: 'creating product',
  updateColorwayActiveFlag: 'updating active flag for product',
  updateColorwayImages: 'updating image for product',
  updateProductName: 'updating name of product',
  updateProductSubTitle: 'updating subtitle for product',
  updateColorway: 'updating product',
  linkSketchToProduct: 'assigning specification to product',
  linkMaterialHardwareToProduct: 'assigning specification to product',
  linkColorToProduct: 'assigning specification to product',
  createComment: 'adding note',
  updateComment: 'updating note',
  deleteComment: 'deleting note',
  deleteProduct: 'deleting product',
  linkMaterial: 'linking specification with PLM',
  updateMaterial: 'updating specification',
  updateMaterialImages: 'updating images for specification',
  linkColor: 'linking specification with PLM',
  updateColor: 'updating specification',
  updateColorImages: 'updating images for specification',
  updateSketch: 'updating specification',
  updateSketchImages: 'updating images for specification',
  deleteMaterialHardwareFromProduct: 'removing specification from product',
  deleteColorFromProduct: 'removing specification from product',
  deleteSketchFromProduct: 'removing specification from product',
  getPublishedModelConfiguration: 'fetching view configuration',
  AddAttributeToProduct: 'adding attribute to type',
  AddAttributeToType: 'adding attribute to type',
  createTypeInModel: 'adding specification type',
  createTypeInProduct: 'adding product type',
  getModelConfiguration: 'fetching configuration',
  EditAttributeForProduct: 'updating attribute',
  EditAttributeForType: 'updating attribute',
  publishModelConfig: 'publishing configuration',
  revertModelConfig: 'reverting configuration changes',
  getTagTypes: 'querying tag types',
  toggleAttributeDeletedFlagForProduct: 'marking attribute as deleted',
  toggleAttributeDeletedFlagForTypeInModel: 'marking attribute as deleted',
  ToggleAttributeRequiredFlagForProduct: 'marking attribute as required',
  ToggleAttributeRequiredFlagForType: 'marking attribute as required',
  toggleDeletedFlagForTypeInProduct: 'marking type as deleted',
  toggleDeletedFlagForTypeInModel: 'marking type as deleted',
  updateTypeInModel: 'updating type',
  updateTypeInProduct: 'updating type',
  updateViewForTypeInModel: 'updating view configuration',
  syncUsers: 'refreshing user information',
  syncHierarchy: 'refreshing hierarchy'
}

export const buildErrorMessage = (errors) => {
  let error = ''

  if (errors) {
    if (errors.operation && errors.operation.operationName && errors.operation.operationName !== 'syncMerchCollection') {
      error = `Error in ${operationMap[errors.operation.operationName] || errors.operation.operationName}: `
    }
    if (errors.networkError) {
      error += errors.networkError.message.split(':')[1] || 'Something went wrong!'
    } else if (errors.graphQLErrors && errors.graphQLErrors.length) {
      if (errors.graphQLErrors.length === 1) {
        error += errors.graphQLErrors[0].message
      } else {
        error += 'Something went wrong'
      }
    } else {
      error += 'Something went wrong!'
    }

    // Log errors to logentries
    logUtils.logErrors(errors)
  }
  return error
}



// WEBPACK FOOTER //
// ./src/utils/errorUtils.ts